var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "gray",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.205 8.205c.399-.4 1.024-.436 1.464-.11l.126.11L12 13.409l5.205-5.204c.399-.4 1.024-.436 1.464-.11l.126.11c.4.399.436 1.024.11 1.464l-.11.126-6 6c-.399.4-1.024.436-1.464.11l-.126-.11-6-6c-.44-.439-.44-1.151 0-1.59z",
    transform: "translate(-78 -673) translate(0 567) translate(16 74) translate(61) translate(2) matrix(-1 0 0 1 24 32)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPicker);
export default __webpack_public_path__ + "static/media/arrow-down-picker.ec6e18f3c027e20b100367049c09aff5.svg";
export { ForwardRef as ReactComponent };